<ng-template [ngTemplateOutlet]="templateElement" [ngTemplateOutletContext]="{ $implicit: masterId }"></ng-template>

<ng-template #typ00 let-recht>
  <cap-link
    [enableNavigation]="false"
    [histinfo]="histInfo"
    [queryParams]="getQueryParams(version)"
    [target]="navTargets.NAV_RECHT"
    [tooltipParams]="{ art: 'PFANDRECHT' | translate }">
    <span>{{ version.pfandrechtform + "_KURZ" | translate }}, </span>
    <span>{{ version | namenInhaberPfandrechtart }}</span>
    <ng-container [ngTemplateOutlet]="common"></ng-container>
  </cap-link>
</ng-template>

<ng-template #typ01 let-recht>
  <cap-link
    [enableNavigation]="false"
    [histinfo]="histInfo"
    [queryParams]="getQueryParams(version)"
    [target]="navTargets.NAV_RECHT"
    [tooltipParams]="{ art: 'PFANDRECHT' | translate }">
    <span>{{ "PFANDRECHT_KURZ" | translate }} </span>
    @if (rechteId) {
      <span>{{ rechteId | formatRechteId }}, </span>
    }
    <span>{{ version.pfandrechtform + "_KURZ" | translate }}, </span>
    @if (pfandstelle || pfandstelle === 0) {
      <span>{{ pfandstelle }}. {{ "Pfandstelle" | translate }}, </span>
    }
    <span>{{ version | namenInhaberPfandrechtart }}</span>
    <ng-container [ngTemplateOutlet]="common"></ng-container>
  </cap-link>
</ng-template>

<ng-template #typ02 let-recht>
  <cap-link
    [enableNavigation]="false"
    [histinfo]="histInfo"
    [queryParams]="getQueryParams(version)"
    [target]="navTargets.NAV_RECHT"
    [tooltipParams]="{ art: 'PFANDRECHT' | translate }">
    <span>{{ version | namenInhaberPfandrechtart }}</span>
    <span><ng-container [ngTemplateOutlet]="common"></ng-container>,</span>
    {{ version.pfandrechtform | translate }}
  </cap-link>
</ng-template>

<ng-template #common>
  @if (version.pfandsumme > 0) {
    , CHF {{ version.pfandsumme | number: "1.2" : "de-CH" }}
  }
  @if (version.maximalzinsfuss) {
    {{ ", " + version.maximalzinsfuss + "%" }}
  }
  @if (version.maximalhypothek) {
    {{ ", " + ("MH" | translate) }}
  }
  @if (version.hinweis) {
    {{ ", " + version.hinweis }}
  }
  @if (version.gesetzlichesPfandrecht) {
    {{ ", " }}{{ version.gesetzlichesPfandrecht?.text | translateName }}
  }
</ng-template>
